import React from 'react';
import {Box, Typography, CircularProgress} from '@mui/material';
import {semantic} from 'src/theme';

// Interface for props
interface OccupancyCardProps {
  occupied: number;
  vacant: number;
}

// Special card for occupancy statistics with visual indicator
export default function OccupancyCard({occupied, vacant}: OccupancyCardProps) {
  // Handle potential division by zero
  const total = occupied + vacant;
  const occupancyRate = total > 0 ? Math.round((occupied / total) * 100) : 0;

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          position: 'relative',
          width: {xs: '120px', sm: '140px', md: '160px'}, // 响应式容器大小
          height: {xs: '120px', sm: '140px', md: '160px'},
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {/* 环形图 - 使用 sx 来控制大小 */}
        <CircularProgress
          variant="determinate"
          value={occupancyRate}
          size={160} // 设置基础大小
          thickness={4}
          sx={{
            color: semantic.success.main,
            position: 'absolute',
            transform: {
              xs: 'scale(0.75)', // 120/160
              sm: 'scale(0.875)', // 140/160
              md: 'scale(1)', // 160/160
            },
          }}
        />
        {/* 中心文字 */}
        <Box
          sx={{
            position: 'absolute',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography
            variant="h4"
            sx={{
              fontSize: {xs: '1.5rem', sm: '2rem', md: '2.5rem'},
              fontWeight: 'bold',
            }}
          >
            {occupancyRate}%
          </Typography>
          <Typography
            variant="caption"
            sx={{
              fontSize: {xs: '0.7rem', sm: '0.8rem', md: '0.9rem'},
              color: 'text.secondary',
            }}
          >
            Occupied
          </Typography>
        </Box>
      </Box>

      {/* 统计信息 */}
      <Box
        sx={{
          mt: {xs: 1, sm: 2},
          display: 'flex',
          gap: {xs: 2, sm: 3},
          justifyContent: 'center',
        }}
      >
        <Box sx={{textAlign: 'center'}}>
          <Typography
            variant="body2"
            sx={{
              fontSize: {xs: '0.75rem', sm: '0.875rem'},
              color: 'text.secondary',
            }}
          >
            Occupied
          </Typography>
          <Typography
            variant="h6"
            sx={{
              fontSize: {xs: '1rem', sm: '1.25rem'},
              fontWeight: 'bold',
            }}
          >
            {occupied}
          </Typography>
        </Box>
        <Box sx={{textAlign: 'center'}}>
          <Typography
            variant="body2"
            sx={{
              fontSize: {xs: '0.75rem', sm: '0.875rem'},
              color: 'text.secondary',
            }}
          >
            Vacant
          </Typography>
          <Typography
            variant="h6"
            sx={{
              fontSize: {xs: '1rem', sm: '1.25rem'},
              fontWeight: 'bold',
            }}
          >
            {vacant}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
